export default __webpack_public_path__ + "static/International Student Policy Handbook-4135554d11190f05785181386358ff1e.pdf";